import { cn } from 'utils/className';
import { TitleProps } from '../types';

const RESPONSIVE_TEXT_CLASS_NAME = 'sm:text-left';

export const Title = ({
  className: propsClassName,
  description,
  ...rest
}: TitleProps) => {
  const containerClassName = cn(
    RESPONSIVE_TEXT_CLASS_NAME,
    'flex flex-col gap-4 w-full text-start',
  );
  const titleClassName = cn(
    propsClassName,
    'text-2xl font-medium text-purple-400 w-full font-figtree',
  );

  return (
    <div className={containerClassName}>
      <h1 className={titleClassName} {...rest} />
      {description && (
        <span className="text-purple-muted-300 text-sm  ">{description}</span>
      )}
    </div>
  );
};
